<template>
    <section id="services">
        <div id="services-header" class="masthead text-white text-center">
            <div class="container h-100 d-flex justify-content-center">
                <div class="my-auto">
                    <hr class="light" data-aos="fade-right">
                    <h1 class="text-white">
                        DE LA ESTRATEGIA <br>
                        <small>a la ejecución</small>
                    </h1>
                    <hr class="light" data-aos="fade-left">
                </div>
            </div>
        </div>
        <div id="back-que-hacemos" class="container-fluid no-repeat-background section-bg">
            <div class="container">
                <div class="row">
                    <div  class="text-dark" style="padding-top: 15px;">
                        <div data-aos="flip-left" class="col-xl-8">
                            <h2 class="">¿Qué hacemos?</h2>
                            <p class="text-justify">En <b>Grupo COSMIC</b> nos esforzamos por crear el mejor sistema para materializar las ideas de nuestros clientes.</p>
                        </div>
                    </div>
                </div>
                <div class="row d-none d-lg-block">
                    <div class="col-xl-12">
                        <img style="width: 70%; height: auto;" src="/../img/esquema_que_hacemos.png">
                    </div>
                </div>

                <div class="row d-lg-none">
                    <div class="col-xl-12 text-center">
                        <h3>Concebimos <span class="text-dark">IDEAS</span></h3>
                        <div class="timeline">
                            <div class="tm-container left">
                                <div data-aos="fade-left" class="content">
                                    <p class="">
                                        Creamos una estrategia ideal para tus objetivos.
                                    </p>
                                </div>
                            </div>
                            <div class="tm-container right">
                                <div data-aos="fade-left" class="content">
                                    <p class="">
                                        Diseñamos los materiales adecuados.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <h3>Preparamos <span class="text-dark">a tu personal</span></h3>
                        <div class="timeline">
                            <div class="tm-container left">
                                <div data-aos="fade-left" class="content">
                                    <p class="">
                                        Realizamos un reclutamiento de alto nivel.
                                    </p>
                                </div>
                            </div>
                            <div class="tm-container right">
                                <div data-aos="fade-left" class="content">
                                    <p class="">
                                        Llevamos la administración correcta del personal.
                                    </p>
                                </div>
                            </div>
                            <div class="tm-container left">
                                <div data-aos="fade-left" class="content">
                                    <p class="">
                                        Tenemos las mejores capacitaciones para tu personal.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <h3>Ejecutamos <span class="text-dark">las estrategias</span></h3>
                        <div class="timeline">
                            <div class="tm-container right">
                                <div data-aos="fade-left" class="content">
                                    <p class="">
                                        En todos los canales (e-merchandising).
                                    </p>
                                </div>
                            </div>
                            <div class="tm-container left">
                                <div data-aos="fade-left" class="content">
                                    <p class="">
                                        Fabricamos material POP.
                                    </p>
                                </div>
                            </div>
                            <div class="tm-container right">
                                <div data-aos="fade-left" class="content">
                                    <p class="">
                                        Nos encargamos de la logística del material.
                                    </p>
                                </div>
                            </div>
                            <div class="tm-container left">
                                <div data-aos="fade-left" class="content">
                                    <p class="">
                                        Implementamos las actividades.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xl-12">
                      <div class="col-xl-7 offset-xl-5">
                            <h2 class="display-3">&nbsp;</h2>
                        </div>
                        <h2 class="text-center">Nuestras certificaciones</h2>
                        <div class="col-xl-7 offset-xl-5">
                            <h2 class="display-3">&nbsp;</h2>
                        </div>
                        
                        <div class="row d-certs-col">
                          <div class="col"><img class="img-fluid" style="max-height: 76px; max-width: 77px; padding-top: 20px;" src="/../img/certifica/sedex.png"></div>
                          <div class="col"><img class="img-fluid" style="max-height: 76px; max-width: 77px; padding-top: 0px;" src="/../img/certifica/bureau.png"></div>
                          <div class="col"><img class="img-fluid" style="max-height: 76px; max-width: 77px; padding-top: 0px;" src="/../img/certifica/amapro.png"></div>
                          <div class="col"><img class="img-fluid" style="max-height: 76px; max-width: 77px; padding-top: 20px;" src="/../img/certifica/repse.png"></div>
                          <div class="col"><img class="img-fluid" style="max-height: 76px; max-width: 77px; padding-top: 0px;" src="/../img/certifica/imc.png"></div>
                          <div class="col"><img class="img-fluid" style="max-height: 76px; max-width: 77px; padding-top: 0px;" src="/../img/certifica/antad.png"></div>
                          <div class="col"><img class="img-fluid" style="max-height: 76px; max-width: 77px; padding-top: 10px;" src="/../img/certifica/dnb.png"></div>
                          <div class="col"><img class="img-fluid" style="max-height: 76px; max-width: 77px; padding-top: 10px;" src="/../img/certifica/igualdad.png"></div>
                          <div class="col"><img class="img-fluid" style="max-height: 76px; max-width: 77px; padding-top: 0px;" src="/../img/certifica/ecovadis.png"></div>
                        </div>
                        <div class="row d-certs text-center">
                          <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/certifica/sedex.png"></div>
                          <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/certifica/bureau.png"></div>
                          <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/certifica/amapro.png"></div>
                          <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/certifica/repse.png"></div>
                          <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/certifica/imc.png"></div>
                          <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/certifica/antad.png"></div>
                          <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/certifica/dnb.png"></div>
                          <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/certifica/igualdad.png"></div>
                          <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/certifica/ecovadis.png"></div>
                        </div>
                        <!-- <div class="row d-certs-col">
                            <div class="col"><img style="padding-top: 20px;" class="img-fluid" src="/../img/reconocimiento1.png"></div>
                            <div class="col"><img                            class="img-fluid" src="/../img/reconocimiento2.png"></div>
                            <div class="col"><img class="img-fluid" src="/../img/reconocimiento3.png"></div>
                            <div class="col" style="padding-top: 42px;"><img class="img-fluid" src="/../img/reconocimientorepse.png"></div>
                            <div class="col"><img class="img-fluid" src="/../img/imnc.png"></div>
                            <div class="col"><img class="img-fluid" src="/../img/reconocimiento5.png"></div>
                            <div class="col"><img class="img-fluid" src="/../img/reconocimiento6.png"></div>
                            <div class="col"><img class="img-fluid" src="/../img/reconocimiento8.png"></div>
                            <div class="col"><img style="padding-top: 40px;" class="img-fluid" src="/../img/reconocimiento9.png"></div>
                        </div>

                        <div class="row d-certs text-center">
                            <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/reconocimiento1.png"></div>
                            <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/reconocimiento2.png"></div>
                            <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/reconocimiento3.png"></div>
                            <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/reconocimientorepse.png"></div>
                            <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/imnc.png"></div>
                            <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/reconocimiento5.png"></div>
                            <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/reconocimiento6.png"></div>                            
                            <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/reconocimiento8.png"></div>
                            <div class="col-lg-3 col-md-6"><img class="img-fluid" src="/../img/reconocimiento9.png"></div>
                        </div> -->
                    </div>
                </div>
                <div class="col-xl-7 offset-xl-5">
                    <h2 class="display-3">&nbsp;</h2>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Services',
    data () {
        return {

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* The actual timeline (the vertical ruler) */
.timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
  content: '';
  position: absolute;
  width: 6px;
  background-color: #b21621;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -3px;
}

/* Container around content */
.tm-container {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 50%;
}

/* The circles on the timeline */
.tm-container::after {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  right: -12px;
  background-color: white;
  border: 4px solid #b21621;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.left {
  left: 0;
}

/* Place the container to the right */
.right {
  left: 50%;
}

/* Add arrows to the left container (pointing right) */
.left::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  right: 30px;
  border: medium solid #b21621;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

/* Add arrows to the right container (pointing left) */
.right::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  left: 30px;
  border: medium solid #b21621;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

/* Fix the circle for containers on the right side */
.right::after {
  left: -12px;
}

/* The actual content */
.content {
  padding: 20px 30px;
  background-color: white;
  position: relative;
  border-radius: 6px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
/* Place the timelime to the left */
  .timeline::after {
    left: 31px;
  }

/* Full-width containers */
  .tm-container {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
  }

/* Make sure that all arrows are pointing leftwards */
  .tm-container::before {
    left: 60px;
    border: medium solid #b21621;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }

/* Make sure all circles are at the same spot */
  .left::after, .right::after {
    left: 18px;
  }

/* Make all right containers behave like the left ones */
  .right {
    left: 0%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/services/Services.vue